import type { ImgHTMLAttributes, ReactElement } from "react";

/** Codex — the purple Codex mark (same asset as the landing page), verbatim. */
export function CodexLogo(
  props: ImgHTMLAttributes<HTMLImageElement>
): ReactElement {
  // eslint-disable-next-line @next/next/no-img-element
  return (
    <img
      src="/brand/codex.svg"
      width={16}
      height={16}
      alt=""
      aria-hidden
      {...props}
    />
  );
}
